define('flight-components/Analytics',['require','flight/lib/component'],function(require){

  var component = require('flight/lib/component');
  
  
  return component(Analytics);

  // Constructor
  function Analytics() {

    this.defaultAttrs({
      
    });

    this.directCall = function(ev, data) {
      if (typeof _satellite !== 'undefined') {
        _satellite.track(data.name);
      }
    };

    this.after('initialize', function() {
      this.on('ui-track-event', this.directCall);
    });

  };

});
